module.exports = __webpack_public_path__ + "static/img/海报@2x.65b8477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/海报@2x.png
// module id = qs9W
// module chunks = 192